import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

const benefits = [
  {
    title: "Tailored to your growth stage",
    description: "Our program is designed to meet you where you are, supporting your unique needs and goals.",
  },
  {
    title: "Hands-on mentoring",
    description: "Work closely with experts who will guide you through the entire process, ensuring measurable progress.",
  },
  {
    title: "Long-term sustainability focus",
    description: "The program emphasizes sustainable development, ensuring your organization's growth lasts for years to come.",
  },
];

const WhyJoin = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6 text-center">
        {/* Section Title */}
        <motion.h2
          className="text-3xl md:text-4xl font-heading font-extrabold text-primary mb-12 tracking-tight"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Why Join This Program?
        </motion.h2>

        {/* Key Benefits Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {benefits.map((benefit, i) => (
            <motion.div
              key={i}
              className="glass-card p-8 bg-white shadow-xl rounded-xl hover:scale-105 transform transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: i * 0.2 }}
            >
              <div className="flex items-center justify-center mb-6">
                <CheckCircle className="w-12 h-12 text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-primary mb-4">{benefit.title}</h3>
              <p className="text-gray-700">{benefit.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Testimonial Section */}
        <motion.div
          className="mt-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="max-w-2xl mx-auto px-6 py-8 bg-white shadow-xl rounded-xl">
            <h3 className="text-2xl font-semibold text-primary mb-4">What Others Say</h3>
            <p className="text-gray-700 italic">
              "This program has been an absolute game changer for our NGO. The personalized mentoring and guidance helped us strengthen our internal processes and operational efficiency. We are now much more confident in our ability to make a long-lasting impact."
            </p>
            <div className="mt-4 text-gray-600 font-semibold">- Jane Doe, NGO Leader</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyJoin;
